'use strict';

import angular from 'angular';

function GroupAttributeTypeResource($resource) {
  return $resource('/api/groups/:groupId/groupattributetypes/:id/:controller', {
    id: '@id'
  }, {
    getDefinedBy: {
      method: 'GET',
      isArray: true,
      params: { controller: 'definedby' }
    },
    getDefinedFor: {
      method: 'GET',
      isArray: true
    },
    getOptions: {
      method: 'GET',
      isArray: true,
      params: { controller: 'options' }
    },
    create: { method: 'POST' },
    update: { method: 'PUT' }
  });
}

GroupAttributeTypeResource.$inject = ['$resource'];

export default angular.module('georgeApp.groupAttributeTypeSvc', [])
  .factory('GrpAtrTypeSvc', GroupAttributeTypeResource)
  .name;
